import React from "react";

import { getRecommendationMode } from "QuotePage/app/compactQuotePage/Selectors";
import { hasPlansBeforeInitialData, getVisiblePlans, getPayrollLead } from "QuotePage/Selectors";
import { isRenewal } from "QuotePage/urls";
import { connect, useSelector } from "react-redux";

import Button from "Common/Button";
import { LinkButton } from "Cobalt/Button";
import { addPlanToCart } from "Common/CartService";

export const StartApplicationButton = ({ plan, onClickStartApplication, disableButtons, customRecommendation, recommendationMode, visiblePlans }) => {
  const payrollLead = useSelector((state) => getPayrollLead(state));

  if (payrollLead?.partner) {
    return (
      <LinkButton size="medium" size="medium" py={4} mt={0} href={`/${payrollLead.partner}/router/payroll-prospect`}>
        Get Started
      </LinkButton>
    );
  }

  return (
    <Button
      disabled={disableButtons}
      onClick={() => {
        onClickStartApplication("medical", plan, {
          location: "view_details",
          custom_recommendation: !!customRecommendation,
          recommendationMode,
          renewal: isRenewal(),
          position: visiblePlans.findIndex((p) => p.id === plan.id) + 1,
        });
      }}
      size="medium"
      py={4}
      mt={0}
    >
      Get Started
    </Button>
  );
};

const mapStateToProps = (state) => ({
  disableButtons: hasPlansBeforeInitialData(state),
  customRecommendation: getRecommendationMode(state) == "recommendation_mode",
  recommendationMode: getRecommendationMode(state),
  visiblePlans: getVisiblePlans(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClickStartApplication: (planType, plan, tracking = {}) => {
    dispatch(
      addPlanToCart({
        planType,
        plan,
        tracking,
        shouldClearDentalVision: false,
        continueToCart: true,
        url: null,
        shouldClearLife: false,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(StartApplicationButton);
